<template>
  <div class="footer">
    <div class="footerTop">
      <span class="ftcff fs14">友情链接</span>
      <span class="ftc14D fs14 cursor" @click="clickOne(1)">E平台业务管理系统</span>
      <span class="ftc14D fs14 cursor" @click="clickOne(2)">废旧物资处置管理系统</span>
      <span class="ftc14D fs14 cursor" @click="clickOne(3)">废旧物资处置服务系统(集团内部)</span>
      <!-- <span class="ftc14D fs14">重庆交运集团废旧物资处置平台</span>
      <span class="ftc14D fs14">重庆交运集团废旧物资处置平台</span>
      <span class="ftc14D fs14">重庆交运集团废旧物资处置平台</span> -->
    </div>
    <div class="ftcff fs14">Copyright © 2021 招标管理系统</div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    clickOne(num) {
      if(num==1) {
        window.location = "http://www.huidaepingtai.com:8031/#/login";
      } else if(num==2) {
        window.location = "http://www.huidaepingtai.com:8032";
      } else {
        window.location = "http://www.huidaepingtai.com:8034";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  // height: 99px;
  padding: 20px 0;
  background: #0c111f;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .footerTop {
    padding-bottom: 10px;

    span {
      padding: 0 0 0 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue